import React, { useEffect, useReducer, useState } from "react";

import "./Containdications.style.scss";
import { Button } from "components/Buttons/Buttons";
import {
  Dropdown,
  Menu,
  Modal,
  Select,
  Space,
  Table,
  Typography,
  Button as AntdButton,
} from "antd";
import { MoreOutlined } from "@ant-design/icons";
import useSettingsHeader from "hooks/useSettingsHeader";
import ContraindicationsDrawer from "./components/ContraindicationsDrawer";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  createContraindication,
  deleteContraindication,
  getAllContraindications,
  restoreContraindication,
  updateContraindication,
} from "services/contraindications.service";
import confirm from "antd/lib/modal/confirm";
import usePortal from "hooks/usePortal";
import SearchAndFilterColumns from "components/SearchAndFilterColumns/SearchAndFilterColumns";
import { push } from "connected-react-router";
const { Title, Text, Link } = Typography;

const reducer = (state, action) => {
  switch (action.type) {
    case "SET":
      return action.data;
    case "ADD":
      return [...state, action.data];
    case "UPDATE":
      return state.map((data) => {
        if (data.contraindicationId === action.data.contraindicationId)
          return action.data;
        return data;
      });
    case "DELETE":
      return state.filter((data) => {
        if (data.contraindicationId === action.data.contraindicationId)
          return false;
        return true;
      });
    default:
      return state;
  }
};

export default function Contraindications() {
  //states start
  const [showAddEditModal, setShowAddEditModal] = useState();
  const [data, localDispatch] = useReducer(reducer, []);

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [activeFilter, setActiveFilter] = useState("active"); // all, active, inactive
  const [searchText, setSearchText] = useState("");
  //states end

  // non-data hooks start
  const dispatch = useDispatch();
  // non-data hooks end

  console.log("data is", data);

  // use effect starts
  const loadData = async () => {
    const result = await dispatch(getAllContraindications());
    if (result?.status === "success") {
      localDispatch({
        type: "SET",
        data: result.data,
      });
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  // use effects end

  // functions start
  const handleAdd = (values) => {
    dispatch(createContraindication(values)).then((result) => {
      if (result?.status === "success") {
        setShowAddEditModal();
        loadData();
        // loadData();
      }
    });
  };
  const handleUpdate = (id, values) => {
    dispatch(updateContraindication(id, values)).then((result) => {
      if (result?.status === "success") {
        setShowAddEditModal();
        loadData();
      }
    });
  };
  const handleDelete = (id) => {
    dispatch(deleteContraindication(id)).then((result) => {
      if (result?.status === "success") {
        loadData();
      }
    });
  };
  const handleRestore = (id) => {
    dispatch(restoreContraindication(id)).then((result) => {
      if (result?.status === "success") {
        loadData();
      }
    });
  };
  const deleteConfirmation = (id) => ({
    title: "Inactivate Contraindication",
    content: (
      <>Are you sure that you want to inactivate the contraindication?</>
    ),
    centered: true,
    maskClosable: true,
    onOk: (close) => {
      handleDelete(id);
      close();
    },
  });

  const restoreConfirmation = (id) => ({
    title: "Activate Contraindication",
    content: <>Are you sure that you want to activate the contraindication?</>,
    centered: true,
    maskClosable: true,
    onOk: (close) => {
      handleRestore(id);
      close();
    },
  });

  const checkActiveFilter = (item) => {
    if (activeFilter === "all") return true;
    else if (activeFilter === "active" && item?.isActive) return true;
    else if (activeFilter === "inactive" && !item?.isActive) return true;
    return false;
  };
  // functions end

  const settingHeaderContent = useSettingsHeader(
    <Space align="center" size="large">
      <AntdButton
        type="text"
        style={{ padding: 0, lineHeight: 1 }}
        onClick={() =>
          dispatch(push("/dashboard/settings/contraindications-rules"))
        }
      >
        Contraindication Rules
      </AntdButton>
      <Button
        rounded={true}
        onClick={() => {
          setShowAddEditModal(true);
        }}
      >
        Create Contraindication
      </Button>
    </Space>
  );

  const columns = [
    {
      title: " Name",
      dataIndex: "contraindicationName",
      key: "contraindicationName",

      sorter: (a, b) => {
        if (
          a.contraindicationName?.toLowerCase?.() <
          b.contraindicationName?.toLowerCase?.()
        )
          return -1;
        if (
          a.contraindicationName?.toLowerCase?.() >
          b.contraindicationName?.toLowerCase?.()
        )
          return 1;
        return 0;
      },
    },
    {
      title: "Active",
      key: "active",
      width: 100,
      render: (data) => {
        if (data?.isActive) return "Active";
        return "Inactive";
      },
    },
    {
      title: "",
      key: "action",
      align: "right",
      width: 80,
      render: (data) => {
        return (
          <Dropdown
            overlay={
              <Menu style={{ borderRadius: 6, border: "2px solid #CDD5D8 " }}>
                <Menu.Item onClick={() => setShowAddEditModal(data)} key="edit">
                  Edit
                </Menu.Item>
                <Menu.Item
                  key="delete"
                  onClick={() => {
                    if (data?.isActive)
                      Modal.warning(
                        deleteConfirmation(data.contraindicationId)
                      );
                    else
                      Modal.warning(
                        restoreConfirmation(data.contraindicationId)
                      );
                  }}
                >
                  {data?.isActive ? "Inactivate" : "Activate"}
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
            getPopupContainer={(triggerNode) => triggerNode?.parentNode}
          >
            <MoreOutlined style={{ fontSize: 18 }} />
          </Dropdown>
        );
      },
    },
  ];

  const searchAndFiltersContent = usePortal(
    "#settingHeader .settingsHeaderLeftSideAddon",
    <Space>
      <SearchAndFilterColumns
        columns={columns}
        hiddenColumns={hiddenColumns}
        setHiddenColumns={(columnTitles) => {
          setHiddenColumns(columnTitles);
        }}
        searchText={searchText}
        setSearchText={(text) => {
          setSearchText(text);
        }}
      />
      <Select
        style={{ width: 120 }}
        value={activeFilter}
        onChange={(value) => {
          setActiveFilter(value);
        }}
        options={[
          {
            value: "all",
            label: "All",
          },
          {
            value: "active",
            label: "Active",
          },
          {
            value: "inactive",
            label: "Inactive",
          },
        ]}
      />
    </Space>
  );

  return (
    <div>
      {settingHeaderContent}
      {searchAndFiltersContent}
      <Table
        tableLayout="auto"
        locale={{ emptyText: "No Contraindications" }}
        rowKey={(data) => data.contraindicationId}
        dataSource={data?.filter(
          (it) =>
            checkActiveFilter(it) &&
            it?.contraindicationName
              ?.toLowerCase?.()
              .includes?.(searchText.toLowerCase())
        )}
        columns={columns.filter((column) => {
          if (!hiddenColumns.includes(column.title)) return true;
          return false;
        })}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: [15, 25, 50, 100, 250],
        }}
        // scroll={{ y: "calc(100vh - 80px - 96px - 60px - 100px)", x: true }}
      />

      <ContraindicationsDrawer
        data={showAddEditModal}
        visible={showAddEditModal}
        onClose={() => {
          setShowAddEditModal();
        }}
        onSuccess={(values) => {
          const isEdit = showAddEditModal?.contraindicationId !== undefined;
          if (isEdit)
            handleUpdate(showAddEditModal?.contraindicationId, values);
          else handleAdd(values);
        }}
      />
    </div>
  );
}
